/**
 * Twinkle Cart — drawer UI components & PDP refresh on remove
 * @module cart-ui
 */
class CartEditButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      localStorage.setItem('edit-product', this.dataset.id);
      localStorage.setItem('edit-product-key', this.dataset.key);
      localStorage.setItem('edit-product-index', this.dataset.index);
      localStorage.setItem('edit-product-handle', this.dataset.handle);
      window.location.href = this.dataset.url;
    });
  }
}

customElements.define('cart-edit-button', CartEditButton);

class UpsellSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.selectShipmentBtn();
    this.backShipmentLayoutBtn();
  }

  selectShipmentBtn() {
    document.querySelector('.cart__select-shipment')?.addEventListener('click', () => {
      document.querySelector('.cart-content__layout')?.classList.add('d-none');
      document.querySelector('.shippment-content__layout')?.classList.remove('d-none');
    });
  }

  backShipmentLayoutBtn() {
    document.querySelector('.drawer__inner-shippment .back')?.addEventListener('click', () => {
      document.querySelector('.shippment-content__layout')?.classList.add('d-none');
      document.querySelector('.cart-content__layout')?.classList.remove('d-none');
    });
  }

  init() {
    const selectBox = document.querySelector('.select-box');
    if (!selectBox) return;

    const selected = selectBox.querySelector('.selected');
    const optionsContainer = selectBox.querySelector('.options-container');
    const optionsList = selectBox.querySelector('.options-list');
    const shippingOptions = optionsList?.querySelectorAll('.option');

    selectBox.addEventListener('click', () => {
      optionsContainer?.classList.toggle('active');
    });

    document.querySelectorAll('.select-box label').forEach((label) => {
      label.addEventListener('click', () => {
        optionsContainer?.classList.remove('active');
      });
    });

    document.addEventListener('click', (event) => {
      if (!selectBox.contains(event.target)) {
        optionsContainer?.classList.remove('active');
      }
    });

    shippingOptions?.forEach((option) => {
      option.addEventListener('click', () => {
        const label = option.querySelector('label');
        const input = option.querySelector('input');
        if (label && input) {
          selected.innerHTML = label.innerHTML;
          this.handleShipmentChange(input.value);
        }
      });
    });

    if (window.Swiper) {
      new Swiper('.cart__upsell_slider', {
        spaceBetween: 40,
        speed: 500,
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        pagination: { el: '.swiper-pagination.upsell_pagination', clickable: true },
        navigation: { prevEl: '.upsell-prev', nextEl: '.upsell-next' },
      });
    }
  }

  handleShipmentChange(selectedOption) {
    const checkoutBtn = document.querySelector('#CartDrawer-Checkout');
    const selectedDateEl = document.querySelector('#calendar .selected');

    if (selectedOption && selectedDateEl) {
      Shopify.theme.cart
        .updateAttributes({
          'Shipment Date': selectedDateEl.dataset.date,
          'Shipment Time Slot': selectedOption,
        })
        .finally(() => {
          if (checkoutBtn) checkoutBtn.disabled = false;
        });
    } else if (checkoutBtn) {
      checkoutBtn.disabled = true;
    }
  }
}

customElements.define('upsell-slider', UpsellSlider);

document.addEventListener('cart:update', (event) => {
  TwinkleCart.refreshPdpAfterCartChange(event.detail?.cart);
});
